<template>
	<div v-if="photos && photos.length > 0"
	     class="b-detail__visual b-gallery b-gallery_big">
		<swiper :options="swiperMainOption" ref="swiperMain" class="swiper b-gallery__slider b-gallery__slider_big">
			<swiper-slide v-for="photo in photos" :key="photo.pid" class="b-gallery__slide b-gallery__slide_big">

				<div class="b-productCard__label b-productCard__label_detail">
					<div class="b-label b-label_small" v-for="sticker in stickers" :class="sticker.code ? sticker.code : ''">
						<span v-html="sticker.name"></span>
					</div>
				</div>

				<div class="b-gallery__imgWrap b-gallery__imgWrap_big">
					<img itemprop="image" class="b-gallery__img b-gallery__img_big" :src="NO_IMAGE" :data-src="photo.src"/>
				</div>
			</swiper-slide>
		</swiper>
		<div class="b-gallery_small">
			<swiper :options="swiperThumbsOption" ref="swiperThumbs"
			        class="swiper b-gallery__slider b-gallery__slider_small">
				<swiper-slide v-for="photo in photos" :key="'thumbs'+photo.pid"
				              class="b-gallery__slide b-gallery__slide_small">
					<div class="b-gallery__imgWrap b-gallery__imgWrap_small">
						<img class="b-gallery__img b-gallery__img_small" :src="NO_IMAGE" :data-src="photo.src"/>
					</div>
				</swiper-slide>
			</swiper>
			<div
				class="gallery-thumbs-button-next swiper-button-next swiper__btn swiper__btn_next b-gallery__btn b-gallery__btn_next">
				<span>
					<svg><use
						xlink:href="/local/templates/main/app/assets/dist/icons/sprite.svg#icons--arrow_left"></use></svg>
				</span>
			</div>
			<div
				class="gallery-thumbs-button-prev swiper-button-prev swiper__btn swiper__btn_prev b-gallery__btn b-gallery__btn_prev">
				<span>
					<svg><use
						xlink:href="/local/templates/main/app/assets/dist/icons/sprite.svg#icons--arrow_right"></use></svg>
				</span>
			</div>
		</div>
		<div class="swiper-pagination gallery-thumbs-swiper-pagination"></div>
	</div>
</template>
<script>

export default {
	name: "CitrusProductSlider",
	props: {
		photos: {
			type: [Array, Object],
			default: () => {
				return [];
			}
		},
		stickers: {
			type: [Array, Object],
			default: () => {
				return [];
			}
		}
	},
	data: function () {
		return {
			swiperMainOption: {
				slidesPerView: 1,
				navigation: {
					nextEl: ".gallery-thumbs-button-next",
					prevEl: ".gallery-thumbs-button-prev"
				},
				watchOverflow: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				preventInteractionOnTransition: true,
				pagination: {
					el: ".gallery-thumbs-swiper-pagination",
				},
			},
			swiperThumbsOption: {
				watchSlidesProgress: true,
				slidesPerView: 'auto',
				freeMode: false,
				navigation: {
					nextEl: ".gallery-thumbs-button-next",
					prevEl: ".gallery-thumbs-button-prev"
				},
				centeredSlides: true,
				centeredSlidesBounds: true,
				watchOverflow: true,
				watchSlidesVisibility: true,
				direction: 'vertical'
			},
			swiperMain: null,
			swiperThumbs: null,
			NO_IMAGE: window.NO_IMAGE
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.hasOwnProperty("swiperMain")) {
				this.swiperMain = this.$refs.swiperMain.swiper;
			}

			if (this.$refs.hasOwnProperty("swiperThumbs")) {
				this.swiperThumbs = this.$refs.swiperThumbs.swiper;

				/**
				 * Привяжем инициализированный слайдер с превью к основному слайдеру (Переинициализация последнего обязательна)
				 * @type {{swiper: null}}
				 */
				this.swiperMainOption.thumbs = {swiper: this.swiperThumbs};
				this.$refs.swiperMain.swiper.destroy();
				this.$refs.swiperMain.mountInstance();
			}

			BX.onCustomEvent(window.ON_UPDATE_DOM);
		});
	}
};
</script>